import { render, staticRenderFns } from "./inventaris.vue?vue&type=template&id=4aee5e5c&scoped=true"
import script from "./inventaris.vue?vue&type=script&lang=js"
export * from "./inventaris.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aee5e5c",
  null
  
)

export default component.exports